module.exports = __webpack_public_path__ + "static/img/jifen@2x.6281b47b.png";